import SchoolPartOfAssociation from './SchoolPartOfAssociation.page';

export default SchoolPartOfAssociation;